import appConfig from '../config/appConfig';
import marketTypeService from './marketTypeService';

interface TransformParams {
    isTransformNeeded: boolean;
    codentify?: string;
    start: number;
    end: number;
}

const transform = ({isTransformNeeded, codentify, start, end}: TransformParams): string | undefined => {
    if (!codentify) return;

    if (isTransformNeeded) {
        let transformedCodentify = '';

        for (let i = 0; i < codentify.length; i++) {
            if (i >= start && i <= end) {
                transformedCodentify = transformedCodentify + '*';
            } else {
                transformedCodentify = transformedCodentify + codentify[i];
            }
        }

        return transformedCodentify;
    }
    return codentify;
};

const transformCodentifyVisual = (codentify?: string) => {
    const hidePartOfCodentify = appConfig.getHidePartOfCodentify();
    const {start, end} = hidePartOfCodentify || {};
    // for start 0 is correct index
    const isTransformNeeded = start !== undefined && !!end;

    return transform({isTransformNeeded, codentify, start: start ?? 0, end: end || 0});
};

const transformCodentifyForIcc = (codentify?: string) => {
    //UA market is DCS type market but as a backend it use DCE backend
    const isTransformNeeded = marketTypeService.isDCS() && !marketTypeService.isUaMarket();

    return transform({isTransformNeeded, codentify, start: 7, end: 9});
};

export default {
    transformCodentifyForIcc,
    transformCodentifyVisual,
};
